import React from 'react';

const ContentTemplateFormModal = React.lazy(() => import('../components/FormModal'));
const contentTemplateModalRegistry = {
    crm_contentTemplateId: ContentTemplateFormModal
};
export default contentTemplateModalRegistry;
